import React from 'react';

const BreadCrumb = ({ title }) => {
  return (
    <React.Fragment>
      <div className="d-sm-flex align-items-center justify-content-between">
        <h4 className="mb-sm-0">{title}</h4>
      </div>
    </React.Fragment>
  );
};

export default BreadCrumb;